import { Id } from '../types/definitions'
import { WorkAPI } from './API'
import Job from './Job'
import { PublishedLegend } from '../legends/PublishedLegend'
import Summary from './Summary'
import { GetQuoteRequest } from '@taxfyle/api-internal/internal/draft_pb'
import { QuoteDto } from './dtos/Quote'
import { DraftPricingDTO } from './dtos/draft-pricing'
import { decimalToNumber, IDecimalAsObject } from 'utils/grpc-util'

/**
 * Summary store.
 */
export default class SummaryStore {
  constructor(private api: WorkAPI) {}

  /**
   * Fetches the summary for the specified Job.
   */
  async fetchSummary(job: Job, legend: PublishedLegend): Promise<Summary> {
    const jobId = Id.assert(job.id)

    const request = new GetQuoteRequest().setId(jobId)
    const pricingDto = await this.api.drafts
      .getQuote(request)
      .then((r) => r.toObject())
      .then(this.mapQuoteToDraftPricingDto)

    return new Summary(pricingDto, job, legend)
  }

  /**
   * Maps the quote to draft pricing dto.
   */
  mapQuoteToDraftPricingDto(quote: QuoteDto): DraftPricingDTO {
    const maybeDecimalToNumber = (value: IDecimalAsObject | undefined) => {
      return value ? decimalToNumber(value) : 0
    }

    return {
      amount_due_now: maybeDecimalToNumber(quote.amountDueNow),
      coupon_amount: maybeDecimalToNumber(quote.coupon?.amount),
      coupon_codes: quote.coupon ? [quote.coupon.code] : [],
      coupon_ids: quote.coupon ? [quote.coupon.id] : [],
      job_scope_item_names: quote.jobScopeItemNamesList,
      primary_amount: maybeDecimalToNumber(quote.primaryAmount),
      total: maybeDecimalToNumber(quote.total),
    }
  }
}
